import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/external/other/icon-date.svg")